export class NoPermissionError extends Error {
    entity: string; 
    identifier: string | undefined;
    additionalIdentifier: string | undefined;
    
    constructor(entity: string, identifier: string | undefined, additionalIdentifier?: string | undefined) {
        super(entity + '|' + identifier);
        this.entity = entity;
        this.identifier = identifier;
        this.additionalIdentifier = additionalIdentifier;
    }

}